import { atom } from 'recoil';

export const isServiceModalOpen = atom<boolean>({
  key: 'service.isModalOpen',
  default: false,
});
